var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 60,
    viewBox: "0 0 512 512",
    width: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.512 150.839-52.271-31.274-11.777-48.75c-5.229-21.621-25.254-36.035-47.212-34.307l-59.81 4.629-34.262-30.336c-16.875-14.399-41.426-14.399-58.359-.015l-34.263 30.35-59.81-4.629c-21.709-1.523-41.997 12.7-46.67 32.534-.967 3.006-18.434 57.301-17.3 53.774l-47.282 28.008c-18.94 11.631-26.528 34.98-18.047 55.518l20.405 49.453-20.39 49.439c-8.496 20.552-.894 43.887 18.032 55.503l52.218 31.055 11.821 48.97c5.2 21.606 25.137 35.947 47.212 34.307l59.165-4.57 34.907 30.692c8.453 7.206 18.81 10.81 29.181 10.81 10.356 0 20.728-3.604 29.18-10.811l34.907-30.692 59.165 4.57c22.354 1.772 42.012-12.686 47.212-34.307l11.777-48.75 52.271-31.274c18.911-11.616 26.499-34.951 18.032-55.503l-20.405-49.438 20.42-49.468c8.467-20.522.879-43.872-18.047-55.488zm-234.512 270.161c-90.981 0-165-74.019-165-165s74.019-165 165-165 165 74.019 165 165-74.019 165-165 165z",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 121c-74.443 0-135 60.557-135 135s60.557 135 135 135 135-60.557 135-135-60.557-135-135-135zm85.605 100.605-90 90c-2.93 2.93-6.768 4.395-10.605 4.395s-7.676-1.465-10.605-4.395l-60-60c-5.859-5.859-5.859-15.352 0-21.211s15.352-5.859 21.211 0l49.394 49.395 79.395-79.395c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352-.001 21.211z",
    fill: "#b7b7b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.2ed6f3507963de3cecf726fb75524491.svg";
export { ForwardRef as ReactComponent };